import type { FamilyBundle, Person } from "../models/types";

function preferredAncestor(node: Person, people: Person[]): Person | null {
  const parents = node.parent_ids
    .map((id) => people.find((p) => p.person_id === id))
    .filter(Boolean) as Person[];
  if (parents.length === 0) return null;

  const blood = parents
    .filter((p) => !p.is_partner)
    .sort((a, b) => a.generation - b.generation)[0];
  if (blood) return blood;

  const partnerParent = parents.find((p) => p.is_partner);
  if (partnerParent?.partner_of) {
    const sundiusLine = people.find((p) => p.person_id === partnerParent.partner_of);
    if (sundiusLine) return sundiusLine;
  }

  return parents.sort((a, b) => a.generation - b.generation)[0] ?? null;
}

export function relationPath(
  bundle: FamilyBundle,
  targetPersonId: string,
): Person[] {
  const people = bundle.people;
  const path: Person[] = [];
  const guard = new Set<string>();
  let current = people.find((p) => p.person_id === targetPersonId) ?? null;

  while (current && guard.add(current.person_id).size === guard.size) {
    path.unshift(current);
    if (current.generation <= 0) break;
    current = preferredAncestor(current, people);
  }

  return path;
}
